/**
 * Hash-based SPA Router
 * Routes: #/ #/shop #/product/:id #/contact #/checkout #/success
 */

const routes = {}
let notFoundHandler = null

export function addRoute(path, handler) {
  routes[path] = handler
}

export function onNotFound(handler) {
  notFoundHandler = handler
}

export function navigate(path) {
  window.location.hash = path
}

function matchRoute(hash) {
  const path = hash.replace(/^#/, '') || '/'

  // Exact match first
  if (routes[path]) {
    return { handler: routes[path], params: {} }
  }

  // Pattern match (e.g. /product/:id)
  for (const routePath of Object.keys(routes)) {
    if (!routePath.includes(':')) continue

    const routeParts = routePath.split('/')
    const pathParts = path.split('/')

    if (routeParts.length !== pathParts.length) continue

    const params = {}
    const matched = routeParts.every((part, i) => {
      if (part.startsWith(':')) {
        params[part.slice(1)] = decodeURIComponent(pathParts[i])
        return true
      }
      return part === pathParts[i]
    })

    if (matched) {
      return { handler: routes[routePath], params }
    }
  }

  return null
}

export function initRouter(outlet) {
  function handleRoute() {
    const hash = window.location.hash || '#/'
    const match = matchRoute(hash)

    if (match) {
      outlet.innerHTML = ''
      match.handler(outlet, match.params)
    } else if (notFoundHandler) {
      outlet.innerHTML = ''
      notFoundHandler(outlet)
    }

    // Scroll to top on navigation
    window.scrollTo({ top: 0, behavior: 'instant' })
  }

  window.addEventListener('hashchange', handleRoute)
  handleRoute()

  // Intercept anchor clicks that start with #
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a')
    if (!link) return
    const href = link.getAttribute('href')
    if (href && href.startsWith('#')) {
      e.preventDefault()
      window.location.hash = href
    }
  })
}

export function getCurrentPath() {
  return window.location.hash.replace(/^#/, '') || '/'
}
